<template>
  <div>
    <AllPhlebioOrders :isPhlebioOrders="phlebo_emr_order"></AllPhlebioOrders>
  </div>
</template>

<script>
const AllPhlebioOrders = defineAsyncComponent(() =>
  import("@/components/phlebioOrders/AllPhlebioOrders")
);
import { defineAsyncComponent } from "vue";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
export default {
  components: {
    AllPhlebioOrders,
  },
  mixins: [UserPermissionsHelper],
  data() {
    return {
      phlebo_emr_order: true,
    };
  },
};
</script>
